// extracted by LIB_CSS_EXTRACT_LOADER
import "./dialog_module.css"
export default {"backdrop":"backdrop-H5SmLu","popup":"popup-JrRLQN","header":"header-SZ8AjW","footer":"footer-O07Mqi","title":"title-fb9wAs","description":"description-F9WLtj","close":"close-tdDrgs"};